export const COUPON_LIKED_LIST_REQUEST = "COUPON_LIKED_LIST_REQUEST";
export const COUPON_LIKED_LIST_SUCCESS = "COUPON_LIKED_LIST_SUCCESS";
export const COUPON_LIKED_LIST_FAILURE = "COUPON_LIKED_LIST_FAILURE";

export const COUPON_LIKE_ADD_REQUEST = "COUPON_LIKE_ADD_REQUEST";
export const COUPON_LIKE_ADD_SUCCESS = "COUPON_LIKE_ADD_SUCCESS";
export const COUPON_LIKE_ADD_FAILURE = "COUPON_LIKE_ADD_FAILURE";

export const COUPON_LIKE_REMOVE_REQUEST = "COUPON_LIKE_REMOVE_REQUEST";
export const COUPON_LIKE_REMOVE_SUCCESS = "COUPON_LIKE_REMOVE_SUCCESS";
export const COUPON_LIKE_REMOVE_FAILURE = "COUPON_LIKE_REMOVE_FAILURE";

export const COUPON_LIKE_CLEAR = "COUPON_LIKE_CLEAR";

